<template>
  <div v-if="!is_success" class="form-wrap">
  
    <div class="form-fields-stack">
    
      <div class="form-field">
        <label for="first_name">First Name</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.first_name"
          id="firstname"
        >
        <span>{{ errors.first_name }}</span>
      </div>

      <div class="form-field">
        <label for="last_name">Last Name</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.last_name"
          id="lastname"
        >
        <span>{{ errors.last_name }}</span>
      </div>

    </div>
    <div class="form-fields-stack two-thirds">

      <div class="form-field">
        <label for="email">Email Address</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.email"
          id="email"
        >
        <span>{{ errors.email }}</span>
      </div>

      <div class="form-field">
        <label for="phone">Phone Number</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.phone"
          id="phone"
        >
        <span>{{ errors.phone }}</span>
      </div>


    </div>

    <div class="form-field">
      <label for="message">Message</label>
      <textarea
        placeholder=""
        v-model="payload.message"
        id="message"
      ></textarea>
      <span>{{ errors.message }}</span>
    </div>

    <div class="form-field">
      <Recaptcha 
        :sitekey="sitekey" 
        submit="contactSubmit">
      </Recaptcha>
    </div>

    <div class="form-field">
      <button
        id="contactSubmit"
        class="button"
        type="submit"
        @click="submitForm()"
      >
        Send Message
      </button>
    </div>

  </div>

  <div v-else>
    <div class="contact-info">
      <span>{{ success_message }}</span>
    </div>
  </div>  
</template>

<script>
import Recaptcha from './Recaptcha.vue';

export default {  
	props: [
		'form_url',
    'sitekey'
	],
  components:{
    Recaptcha
  },

	data () {
    return {
      payload: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null
      },
      errors: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
        files: null
      },
      is_success : false,
      success_message : ""
    }
  },

	mounted () {},
  
  methods: {
    clearErrors(){
      this.errors = {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
        files: null
      };
    },
		submitForm () {
      this.clearErrors();
			axios.post(this.form_url, this.payload)
        .then((response) => {					
          this.is_success = response.data.success
          this.success_message = response.data.message
				})
				.catch((error) => {
					console.log(error);
					if (error.response.status == 422) {
						
						$.each(error.response.data.errors, (remote_key, remote_value) => {              
							if (remote_key == 'first_name') {
								this.errors.first_name = remote_value[0]
							}
							if (remote_key == 'last_name') {
								this.errors.last_name = remote_value[0]
							}
							if (remote_key == 'email') {
								this.errors.email = remote_value[0]
							}
							if (remote_key == 'phone') {
								this.errors.phone = remote_value[0]
							}
							if (remote_key == 'message') {
								this.errors.message = remote_value[0]
							}
						});
					}
				});
      
		}
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ContactForm.vue